import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-400 py-6 px-4 text-center text-sm" data-id="element-126">
      <div className="max-w-4xl mx-auto" data-id="element-127">
        <p className="font-bold text-white text-base mb-1" data-id="element-128">ARTE BORDADO™</p>
        <p data-id="element-129">© 2026 — Todos los derechos reservados.</p>
      </div>
    </footer>;
}